export class Venue {
    id: number;
    translations: any;

    constructor(obj?: any) {
        this.id = obj && obj.id;
        this.translations = obj && obj.translations;
    }
}
